import { createContext } from "react";

export const NewRequestContext = createContext();
